export default {
  toasts: {
    load_error: 'Zahlungseinrichtung konnte nicht geladen werden',
    rails_saved: 'Zahlungswege gespeichert',
    gateway_registered: 'Gateway registriert',
    redact_failed: 'Gateway konnte nicht entfernt werden',
    gateway_redacted: 'Gateway entfernt',
    sca_provisioned: '3DS2-Registrierung erstellt',
    company_assigned: 'Restaurant zugewiesen',
    default_set: 'Standard-Gateway gesetzt — neue Restaurants werden ihm automatisch zugewiesen',
    default_failed: 'Standard-Gateway konnte nicht gesetzt werden',
    primary_switched: 'Primäres Gateway auf {{gateway}} umgestellt',
    primary_switch_failed: 'Primäres Gateway konnte nicht umgestellt werden',
  },
  custody: {
    title: 'Wer wickelt die Zahlungen ab',
    description:
      'Wird einmalig beim ersten Speichern des Zahlungswegs festgelegt und danach gesperrt: Mit dem eigenen Gateway verwahrt der Partner die Gelder; über das FoodAmigos-Adyen-Konto verwahrt FoodAmigos sie und zahlt den Anteil des Partners monatlich aus.',
    options: {
      provider: 'Eigenes Gateway des Partners',
      platform: 'FoodAmigos wickelt Zahlungen ab',
    },
    locked_notice: 'Durch die Zahlungskonfiguration auf „{{custodian}}“ festgelegt — kann nicht mehr geändert werden.',
    pick_first: 'Wählen Sie zuerst, wer die Zahlungen abwickelt.',
    lock_confirm: {
      title: 'Zahlungen auf „{{custodian}}“ festlegen?',
      description:
        'Mit dem Speichern wird festgelegt, wer die Gelder dieses Partners verwahrt — das kann nicht rückgängig gemacht werden, auch nicht durch den Support. Der Zahlungsweg lässt sich später noch ändern, wer die Zahlungen abwickelt nicht.',
      confirm: 'Festlegen und speichern',
    },
  },
  rails: {
    title: 'Zahlungsweg',
    description:
      'Über welchen Zahlungsanbieter dieser Partner abrechnet — immer nur einen. Restaurants können nur auf den hier gewählten Zahlungsweg umgestellt werden, und ein Zahlungsweg kann nicht ersetzt werden, solange Restaurants darüber abrechnen.',
    save: 'Zahlungsweg speichern',
    multiple_warning:
      'Dieser Partner nutzt noch mehr als einen Zahlungsweg ({{rails}}). Beim Speichern bleibt nur der oben gewählte übrig, die übrigen werden entfernt — und die Änderung wird abgelehnt, wenn noch ein Restaurant über einen davon abrechnet.',
    options: {
      stripe: 'Stripe',
      adyen: 'Adyen',
      spreedly: 'Lokales Gateway über Spreedly',
    },
    platform_stripe_unavailable: 'Stripe über die FoodAmigos-Konten ist noch nicht verfügbar.',
    platform_custody_notice: 'Nicht verfügbar, wenn FoodAmigos die Zahlungen abwickelt.',
    provider_custody_adyen_notice:
      'Nicht verfügbar, wenn der Partner ein eigenes Gateway mitbringt — Adyen ist die Zahlungsschiene der FoodAmigos-Abwicklung.',
  },
  spreedly_section_title: 'Spreedly-Einrichtung',
  gateways: {
    title: 'Gateways',
    description:
      'Die eigenen PSP-Konten des Partners. Der gesamte Zahlbetrag wird beim Acquirer des jeweiligen Gateways abgerechnet.',
    register: 'Gateway registrieren',
    empty: 'Noch keine Gateways registriert',
    columns: {
      gateway: 'Gateway',
      status: 'Status',
      sca: '3DS2',
      companies: 'Restaurants',
    },
    statuses: {
      active: 'Aktiv',
      redacted: 'Entfernt',
    },
    sca: {
      sandbox: '3DS2-Sandbox',
      live: '3DS2 live',
      none: 'Kein 3DS2',
    },
    default_tag: 'Standard',
    actions: {
      make_default: 'Als Standard festlegen',
      check: 'Prüfung ausführen…',
      sca_provision: '3DS2 einrichten…',
      sca_manage: '3DS2-Registrierung…',
      redact: 'Gateway entfernen',
    },
  },
  redact_confirm: {
    title: '{{gateway}} entfernen?',
    description:
      'Die Zugangsdaten werden bei Spreedly gelöscht und können nicht wiederhergestellt werden. {{count}} zugewiesene(s) Restaurant(s) rechnen weiterhin über dieses Gateway ab — solange Restaurants zugewiesen sind, wird das Entfernen abgelehnt und Sie werden erneut um Bestätigung gebeten.',
    redact: 'Entfernen',
    force_title: '{{gateway}} trotzdem entfernen?',
    force_description:
      '{{count}} Restaurant(s) sind diesem Gateway noch zugewiesen. Wenn Sie es jetzt entfernen, wird deren Checkout abgelehnt, bis ihnen ein anderes Gateway zugewiesen wird. Dies kann nicht rückgängig gemacht werden.',
    force_redact: 'Trotzdem entfernen',
  },
  companies: {
    title: 'Restaurants',
    description: 'Über welchen Anbieter jedes Restaurant abrechnet und welches Spreedly-Gateway zugewiesen ist.',
    empty: 'Keine Restaurants',
    no_gateway: 'Keins',
    unassigned: 'Nicht zugewiesen',
    assignment_error_label: 'Automatische Zuweisung fehlgeschlagen',
    assign: 'Zuweisen',
    reassign: 'Neu zuweisen',
    columns: {
      restaurant: 'Restaurant',
      primary_gateway: 'Primäres Gateway',
      spreedly: 'Spreedly-Gateway',
    },
    switch_primary_to: 'Zu {{gateway}} wechseln',
    assign_modal: {
      title: '{{company}} einem Gateway zuweisen',
      assign: 'Zuweisen',
      gateway: 'Gateway',
      make_primary: 'Spreedly zusätzlich als primäres Gateway setzen',
      make_primary_hint: 'Zahlungen laufen nur über Spreedly, solange es das primäre Gateway ist.',
    },
  },
  register_modal: {
    title: 'Gateway registrieren',
    register: 'Registrieren',
    gateway_type: 'Gateway-Typ',
    gateway_type_placeholder: 'Spreedly-Katalog durchsuchen…',
    auth_mode: 'Authentifizierungsmodus',
    no_credentials: 'Dieser Gateway-Typ benötigt keine Zugangsdaten (Spreedly-Sandbox).',
    description: 'Beschreibung',
    description_placeholder: 'z. B. Acme Eats — Braintree EUR',
    acquirer_merchant_id: 'Acquirer-Händler-ID',
    acquirer_hint: 'Optional — nur zusammen mit MCC erforderlich',
    mcc: 'MCC',
    mcc_hint: '4 Ziffern, z. B. 5812',
    make_default: 'Als Standard des Partners verwenden',
    make_default_hint:
      'Neue Restaurants des Partners und Restaurants ohne Gateway werden ihm zugewiesen. Leer lassen, wenn es der eigene Acquirer eines einzelnen Restaurants ist.',
  },
  sca_modal: {
    title: '3DS2-Registrierung — {{gateway}}',
    provision: 'Bereitstellen',
    irreversible_warning:
      'Unumkehrbar: Weder das Händlerprofil noch der SCA-Provider können nachträglich bearbeitet oder gelöscht werden. Eine falsche Acquirer-BIN fällt erst bei der Zahlung auf. Bitte prüfen Sie jeden Wert mit der Acquiring-Bank, bevor Sie bereitstellen.',
    already_provisioned:
      'Bereits vorhanden (Provider-Token {{token}}). Eine erneute Bereitstellung liefert die bestehende Registrierung zurück, sofern „Neu erstellen“ nicht aktiviert ist.',
    type: {
      label: 'Provider-Typ',
      hint: '„Test“ simuliert Authentifizierungsergebnisse und wird in Produktion abgelehnt.',
      test: 'Test (SCA-Sandbox)',
      live: 'Live (Spreedly 3DS2 Global)',
    },
    country: {
      hint: 'Das Land, unter dem die akquirierende Bank diesen Händler registriert hat — nicht zwingend der Sitz des Partners. Gilt für alle Kartennetzwerke unten.',
      differs_warning:
        'Das ist nicht das Land des Partners ({{country}}). Korrekt, wenn der Acquirer den Händler anderswo registriert hat — andernfalls bitte prüfen, denn ein Händlerprofil kann nach dem Anlegen nicht mehr geändert werden.',
    },
    network_placeholder: 'Kartennetzwerk',
    add_network: 'Kartennetzwerk hinzufügen',
    networks: {
      visa: 'Visa',
      mastercard: 'Mastercard',
      amex: 'American Express',
      discover: 'Discover',
      diners: 'Diners',
      jcb: 'JCB',
      dankort: 'Dankort',
      union_pay: 'UnionPay',
      cartes_bancaires: 'Cartes Bancaires',
    },
    fields: {
      acquirer_merchant_id: 'Acquirer-Händler-ID',
      acquirer_bin: 'Acquirer-BIN',
      mcc: 'MCC',
      merchant_name: 'Händlername',
      country_code: 'Land (ISO-2)',
      merchant_url: 'Händler-URL',
    },
    recreate: {
      label: 'Registrierung neu erstellen',
      hint: 'Verwirft das aktuelle Händlerprofil und den SCA-Provider unwiderruflich und erstellt neue.',
    },
  },
  check_modal: {
    title: 'Gateway prüfen — {{gateway}}',
    run: 'Prüfung ausführen',
    done: 'Fertig',
    failed: 'Die Prüfung konnte nicht ausgeführt werden.',
    types: {
      verify: 'Verifizierung (kein Geldfluss)',
      test_payment: 'Testzahlung',
    },
    verify_unsupported:
      'Dieser Gateway-Typ unterstützt keine Verifizierung — führen Sie stattdessen eine Testzahlung durch.',
    test_payment_warning:
      'Auf einem Live-Gateway wird eine echte Zahlung ausgeführt und sofort erstattet. In SCA-Märkten kann die Bank die Zahlung ohne 3DS ablehnen — auch das belegt, dass die Zugangsdaten den Acquirer erreichen.',
    amount: 'Betrag',
    amount_help: 'Zwischen 1,00 und 5,00',
    check_passed: 'Prüfung bestanden',
    check_failed: 'Prüfung fehlgeschlagen — siehe Schritte unten',
    legs: {
      verify: 'Verifizierung',
      purchase: 'Zahlung',
      credit: 'Erstattung',
    },
    leg_passed: 'Bestanden',
    leg_failed: 'Fehlgeschlagen',
  },
  card_fields: {
    script_failed:
      'Das Spreedly-Skript konnte nicht geladen werden. Bitte prüfen Sie die Verbindung und versuchen Sie es erneut.',
    full_name: 'Karteninhaber',
    number: 'Kartennummer',
    expiry: 'Gültig bis',
    cvv: 'CVV',
  },
};
